export const EN_NUMBER_FORMAT = /[+-]?\d{1,3}(?:([.,])\d{3})*(?:\1\d+)?|\d+(?:([.,])\d+)?/;
export const DE_NUMBER_FORMAT = /[+-]?\d{1,3}(?:([.,])\d{3})*(?:\1\d+)?|\d+(?:([.,])\d+)?/;
export const EN_ALL_NUMBER_FORMAT = /^[+-]?\d{1,100}(?:,\d{3})*(?:\.\d*)?$/;
export const DE_ALL_NUMBER_FORMAT = /^[+-]?\d{1,100}(?:\.\d{3})*(?:,\d*)?$/;
export const createValidDecimalRegex = (decimalPlaces: number) => {
    if (!Number.isInteger(decimalPlaces) || decimalPlaces < 0 || decimalPlaces > 10) {
        throw new Error('Invalid decimalPlaces value');
    }
    if (decimalPlaces === 0) {
        return /^-?\d+[.,]?0?$/;
    }
    return new RegExp(`^-?\\d+[.,]?\\d{0,${decimalPlaces}}$`);
};
